
import store from '@/store/index'

function hasPermission(permission) {
  if (store.getters.is_system === 1) {
    return true
  }
  return store.getters.permissions.some(v => {
    return v === permission
  })
}

export function auth(value) {
  let auth
  if (typeof value === 'string') {
    auth = hasPermission(value)
  } else {
    auth = value.some(item => {
      return hasPermission(item)
    })
  }
  return auth
}

export function authAll(value) {
  const auth = value.every(item => {
    return hasPermission(item)
  })
  return auth
}
